<template>
  <b-form @submit.prevent="guardar">

    <b-form-row>
      <b-form-group class="col-md-12">
        <label for="toxicidad">
          Toxicidad <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="toxicidad"
                         name="toxicidad"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.toxicidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.toxicidad')"
        />
      </b-form-group>
      <b-form-group class="col-md-12 bg-row-gray">
        <label for="persistencia_degradabilidad">
          Persistencia y degradabilidad <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="persistencia_degradabilidad"
                         name="persistencia_degradabilidad"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.persistencia_degradabilidad"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.persistencia_degradabilidad')"
        />
      </b-form-group>
      <b-form-group class="col-md-12">
        <label for="potencial_bioacumulacion">
          Potencial de bioacumulación <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="potencial_bioacumulacion"
                         name="potencial_bioacumulacion"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.potencial_bioacumulacion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.potencial_bioacumulacion')"
        />
      </b-form-group>
      <b-form-group class="col-md-12 bg-row-gray">
        <label for="movilidad_suelo">
          Movilidad en el suelo <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="movilidad_suelo"
                         name="movilidad_suelo"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.movilidad_suelo"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.movilidad_suelo')"
        />
      </b-form-group>
      <b-form-group class="col-md-12">
        <label for="resultados_valoracion">
          Resultados de la valoración PBT y mPmB <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="resultados_valoracion"
                         name="resultados_valoracion"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.resultados_valoracion"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.resultados_valoracion')"
        />
      </b-form-group>
      <b-form-group class="col-md-12 bg-row-gray">
        <label for="otros_efectos_adversos">
          Otros efectos adversos <span style="color: red">(*)</span>
        </label>
        <b-form-textarea id="otros_efectos_adversos"
                         name="otros_efectos_adversos"
                         required
                         data-vv-as=" "
                         v-model="selectedSeccion12.otros_efectos_adversos"
        />
        <span class="text-danger span-error small"
              v-text="errors.first('crearActualizarSeccion12.otros_efectos_adversos')"
        />
      </b-form-group>
    </b-form-row>

    <!-- Modal Ecotoxicidades -->
    <b-modal id="toxicidades-modal"
             title="Ecotoxicidades"
             size="lg"
             @show="getToxicidades()"
    >
      <ModalToxicidades />
    </b-modal>

    <hr>
    <FooterButtons back="/fds/listar" :buttons="footerButtons" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';
import ModalToxicidades from "@/views/fds/productos/componentes/ModalToxicidades.vue";

export default {
  name: "FDS-Seccion12",
  components: {
    FooterButtons,
    ModalToxicidades,
  },
  data() {
    return {
      footerButtons: [
        {
          key: 'btonModalToxicidades',
          variant: 'primary',
          class: 'fa fa-flask fa-lg',
          type: 'modal',
          text: 'Ecotoxicidades',
          ref: 'toxicidades-modal',
        },
      ]
    }
  },
  async created() {
    await this.setSeccionActual(12);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.setTipoToxicidad('ecotoxicidad');
    } else {
      await this.resetSeccion();
    }
  },
  methods: {
    async guardar() {
      if (this.accion === 'crear') {
        await this.crearSeccion();
      } else if (this.accion === 'editar'){
        await this.actualizarSeccion();
      }
    },
    ...mapMutations('fds_productos', [
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'setTipoToxicidad',
    ]),
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion',
      'getToxicidades',
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'resetSeccion',
    ]),
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion12',
      'tipo_toxicidad'
    ])
  }
}
</script>
<style scoped>
.bg-row-gray {
  background-color: #f0f3f5 !important;
  margin-top: 0.5em !important;
  padding-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-bottom: 0.5em !important;
}
</style>
